import React, { useState } from 'react';
import '@material/web/button/filled-tonal-button.js';
import './SearchBar.css';
import { MdSearch } from 'react-icons/md'; // icon for the Search bar

// Define the SearchBar component
const SearchBar = ({onSearch}) => {
    // Create a state variable to store the user's input
    const [searchTerm, setSearchTerm] = useState('');

    // Called when the user clicks the "Search" button
    const handleSearchClick = () => {
        if (onSearch) {
            onSearch(searchTerm); // Send the search term to the parent component
        }
    };
    return(
        <div className="search" dir="rtl">
            <MdSearch className="search-icon" />
            <input
                type="text"
                className="search-input"
                placeholder="חפש כאן..."
                value={searchTerm}
                onChange={(e) => {
                    const value = e.target.value;
                    setSearchTerm(value);
                    if (onSearch) onSearch(value); // ⬅️ live update
                }}
            />

            <md-filled-tonal-button onClick={handleSearchClick} className="search-button">
                חיפוש
            </md-filled-tonal-button>

        </div>
    );
};

export default SearchBar; // Export the component so it can be used elsewhere


